export default "__VITE_ASSET__DZ$E458r__"